class ScrollingContent extends window.BAO.CustomElement() {
  static get styles () {
    return ':host { display: block; }'
  }

  connectedCallback () {
    super.connectedCallback()

    this.setContentHeight()
  }

  setupListeners () {
    super.setupListeners()
  }

  setContentHeight () {
    this.style = `--ContentHeight: ${this.offsetHeight}px`
  }
}

if (!customElements.get('scrolling-content')) {
  customElements.define('scrolling-content', ScrollingContent)
}
